module.exports = __webpack_public_path__ + "assets/images/icons/icon_x-red.svg?v=5b862aed";